import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="classic-tabs"
export default class extends Controller {
  connect() {}
}
